import { ButtonLink, TLink } from "@/components/molecules/Button";
import { Container } from "@/components/molecules/Container";
import { LogoMulti } from "@/components/molecules/logos/LogoMulti";
import { LogoThin } from "@/components/molecules/logos/LogoThin";
import { useBudouX } from "@/hooks/useBudouX";
import {
  faAngleRight,
  faArrowUpRightFromSquare,
  faBars,
  faMapLocationDot,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, Transition } from "@headlessui/react";
import clsx from "clsx";
import Link from "next/link";
import { motion } from "framer-motion";
import { Fragment, useEffect, useState, useRef } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";

const sns = [
  {
    name: "X",
    href: "https://x.com/toccasystems",
    icon: () => (
      <svg width="20" height="20" viewBox="0 0 1200 1227" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/toccasystems/",
    icon: FaInstagram,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/toccasystems/",
    icon: FaFacebook,
  },
];
const globalNavi = [
  { name: "About", href: "/about" },
  { name: "Service", href: "/service" },
  { name: "Product", href: "/product" },
  { name: "Project", href: "/project" },
  { name: "Event", href: "/event" },
  { name: "News", href: "/news" },
  { name: "Contact", href: "/contact" },
];
// グローバルナビは領域が限られるため、Identity / Careers はフッターのみに置く（2026-08）。
// TWP は Solution の左に並べる（自社プロダクトを先に見せる）。
const externalNavi = [
  { name: "TWP", href: "https://twp-saas.tocca.systems/", isExternal: true },
  { name: "Solution", href: "https://solution.tocca.systems/", isExternal: true },
];
const subNavi2 = [
  { name: "プライバシー・ポリシー", href: "/policy" },
  { name: "TWP プライバシーポリシー", href: "/twp/privacy" },
  { name: "サイトのご利用について", href: "/terms" },
  { name: "商取引法に基づく表記", href: "/legal" },
  { name: "ISMS基本方針", href: "/isms" },
  { name: "QMS基本方針", href: "/qms" },
];

function MobileNavigation(props) {
  const { parse } = useBudouX();
  return (
    <Popover className="">
      {({ open, close }) => (
        <>
          <Popover.Button className=" relative z-50 flex items-center justify-center rounded-md border-0 p-2 text-lg text-pri hover:text-org focus:outline-none focus:ring-2 focus:ring-inset [&:not(:focus-visible)]:focus:outline-none">
            <span className="sr-only">Open menu</span>
            {open ? (
              <FontAwesomeIcon icon={faXmark} className="text-white" />
            ) : (
              <FontAwesomeIcon icon={faBars} />
            )}
          </Popover.Button>

          <Transition.Root>
            <Transition.Child
              as={Fragment}
              enter="duration-150 ease-out"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="duration-150 ease-in"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Popover.Overlay className="fixed inset-0 h-full bg-nvy/90" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="duration-150 ease-out"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="duration-100 ease-in"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Popover.Panel
                as="div"
                className="absolute inset-x-0 top-full mt-4 h-[75vh] origin-top overflow-y-scroll rounded-md bg-white text-txt-base"
              >
                <h2 className="pt-8 pb-6">
                  <Link href="/">
                    <a className="flex min-h-full items-center justify-center">
                      <span className="sr-only">Home</span>
                      <LogoMulti className="h-[120px] w-[79px]" />
                    </a>
                  </Link>
                </h2>
                                <ul className="grid w-full list-none grid-cols-2 border-t border-bdc-light">
                                  {globalNavi.map((item) => (
                                    <li
                                      key={item.name}
                                      className="border-r border-b border-bdc-light even:border-r-0"
                                    >
                                      <Link href={item.href}>
                                        <a
                                          className="flex h-14 w-full items-center justify-center text-md font-bold text-pri hover:text-hov"
                                          rel="noreferrer"
                                        >
                                          {item.name}
                                        </a>
                                      </Link>
                                    </li>
                                  ))}
                                  {externalNavi.map((item) => (
                                    <li
                                      key={item.name}
                                      className="border-r border-b border-bdc-light even:border-r-0"
                                    >
                                      <a
                                        href={item.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex h-14 w-full items-center justify-center gap-1 text-md font-bold text-pri hover:text-hov"
                                      >
                                        {item.name}
                                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                <div className="space-y-1 p-4 pb-3">
                  <h4 className=" text-sm font-bold text-ter">
                    アクセスマップ
                  </h4>
                  <dl className="text-sm text-txt-base">
                    <dd>
                      {parse(
                        "地下鉄半蔵門線・新宿線・三田線　神保町駅A4出口から徒歩2分"
                      )}
                    </dd>
                    <dd>
                      {parse(
                        "地下鉄東西線・半蔵門線・新宿線　九段下駅から徒歩8分"
                      )}
                    </dd>
                    <dd>
                      {parse("JR中央・総武緩行線　水道橋駅東口から徒歩8分")}
                    </dd>
                  </dl>
                  <ButtonLink
                    href="https://goo.gl/maps/QCfjpiCLH5BptRdE6"
                    variant="outline"
                    color="sec"
                    className="w-full rounded-md"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="mr-2">
                      <FontAwesomeIcon icon={faMapLocationDot} />
                    </i>
                    googlemapで見る
                  </ButtonLink>
                </div>
                <div className="px-4 pb-2">
                  <h4 className=" text-sm font-bold text-ter">住所</h4>
                  <dl className="text-sm text-txt-base">
                    <dd>
                      <TLink
                        href="https://goo.gl/maps/QCfjpiCLH5BptRdE6"
                        variant="light"
                        color="pp"
                        className="w-full rounded-md"
                        target="_blank"
                        rel="noreferrer"
                      >
                        101-0051
                        <br />
                        東京都千代田区神田神保町2-20 ワカヤギビル3階
                      </TLink>
                    </dd>
                  </dl>
                </div>
                <div className="px-4 pb-2">
                  <h4 className=" text-sm font-bold text-ter">電話番号</h4>
                  <dl className="text-sm text-txt-base">
                    <dd>
                      <a
                        href="tel:03-5213-4278"
                        className="text-sm  hover:text-hov md:text-base"
                      >
                        03-5213-4278
                      </a>
                    </dd>
                  </dl>
                </div>
                <ul className="flex flex-row flex-wrap gap-x-2 gap-y-0 px-4 pt-2 text-sm">
                  {subNavi2.map((nav) => (
                    <li key={nav.name}>
                      <Link
                        href={nav.href}
                        className="text-pri md:border-x-0 md:border-t-0 md:border-b md:border-solid"
                      >
                        <a className="px-0 font-bold hover:text-hov md:pb-4">
                          <i className="mr-2 text-icn md:hidden">
                            <FontAwesomeIcon icon={faAngleRight} />
                          </i>
                          {nav.name}
                          <span className="text-xs">{nav.sub}</span>
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
                <ul className="flex flex-row flex-wrap justify-center gap-x-8 px-4 py-8 text-sm">
                  {sns.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        target="_blank"
                        className=" flex items-center rounded-full hover:bg-gray-50"
                        rel="noreferrer"
                      >
                        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-icn hover:text-hov md:h-10 md:w-10 lg:h-10 lg:w-10">
                          <item.icon
                            className="h-6 w-6 lg:h-6 lg:w-6"
                            aria-hidden="true"
                          />
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="border-x-0 border-t border-b-0 border-solid border-bdc-light px-4 pt-4 pb-6 text-center">
                  <h6 className="text-xs">
                    ©&nbsp;ToccaSystems Co., Ltd. All Rights Reserved.
                  </h6>
                </div>
              </Popover.Panel>
            </Transition.Child>
          </Transition.Root>
        </>
      )}
    </Popover>
  );
}

export function Header({ className, isRelative }) {
  const [isVisible, setIsVisible] = useState(false);
  // const headerPosition = isVisible ? "fixed md:top-[0px]" : "fixed md:absolute";

  const headerPosition = isRelative
    ? isVisible
      ? "fixed top-[0.01px]"
      : "relative top-[0.01px] border-b-0 shadow-none md:backdrop-none md:backdrop-blur-none"
    : isVisible
    ? "fixed top-[0.01px] md:top-[0px] "
    : "fixed md:absolute top-[-80px] shadow md:backdrop-blur-lg border-b border-b-bdc-light shadow md:backdrop-blur-lg";
  const headerRef = useRef(null);

  const toggleVisibility = () => {
    window.scrollY > 4 ? setIsVisible(true) : setIsVisible(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <motion.header
      ref={headerRef}
      className={clsx(
        className,
        headerPosition,
        "z-100 w-full border-b border-b-bdc-light bg-white py-3  md:backdrop-opacity-80"
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1, ease: "easeInOut" }}
    >
      <Container className="pl-6 pr-4 sm:pl-8 md:pl-12 md:pr-6">
        <div className="relative z-50 flex items-center justify-between">
          <h1>
            <Link href="/">
              <a className="flex min-h-full items-center justify-center">
                <span className="sr-only">Home</span>
                <LogoThin className="h-[24px] w-[auto] md:h-[28px] lg:h-[32px]" />
              </a>
            </Link>
          </h1>
          <div className="relative hidden items-center gap-4 text-sm xs:hidden lg:flex xl:gap-8">
                        <ul className="flex list-none gap-6 md:gap-3 xl:gap-6">
                          {globalNavi.map((item) => (
                            <li key={item.name}>
                              <Link href={item.href}>
                                <a
                                  className="text-base font-bold text-pri hover:text-hov"
                                  rel="noreferrer"
                                >
                                  {item.name}
                                </a>
                              </Link>
                            </li>
                          ))}
                          {externalNavi.map((item) => (
                            <li key={item.name}>
                              <a
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-1 text-base font-bold text-pri hover:text-hov"
                              >
                                {item.name}
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                              </a>
                            </li>
                          ))}
                        </ul>
            <ul className="flex items-center">
              {sns.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    target="_blank"
                    className=" flex items-center rounded-full hover:bg-gray-50"
                    rel="noreferrer"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-icn hover:text-hov sm:h-12 sm:w-12">
                      <item.icon className="h-5 w-5" aria-hidden="true" />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:hidden">
            <MobileNavigation />
          </div>
        </div>
      </Container>
    </motion.header>
  );
}
